export default __webpack_public_path__ + "static/media/stillLife2.fbae5a17.jpg";